import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./VideoList.scss";
import {
    fetchContentNotConvertAll
} from '../services/apiContent';
import { BASE_URL } from "../services/constant";

const VideoList = () => {
  const [search, setSearch] = useState("");
  const [videos, setVideos] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;

  
  const navigate = useNavigate();
  

  // Données fictives de test (à remplacer par ton API)
  useEffect(() => {
    
    let mounted = true;
    async function load() {
      try {
    
          const data = await fetchContentNotConvertAll(); 
          
          setVideos(data);
        } catch (err) {
        console.error(err);
        }
    }
    load();
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    setFiltered(
      videos.filter((v) =>
        v.title.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [search, videos]);

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const displayed = filtered.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );
  // Limiter la description
function limitText(text, max = 250) {
  if (!text) return "";
  return text.length > max ? text.substring(0, max) + "..." : text;
}

// Convertir durée (secondes → HH:MM:SS)
function formatDuration(seconds) {
  if (!seconds || isNaN(seconds)) return "00:00";

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  // si 0 heure : n'afficher que mm:ss
  if (h === 0) {
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }

  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(
    s
  ).padStart(2, "0")}`;
}

// Formater date MySQL → "26 Aug 2022"
function formatDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}


  return (
    
    <div className="page-content">
    <div className="video-list-container">
      <h2 className="page-title">Channel content</h2>

      {/* Tabs */}
      <div className="tabs">
        <button className="tab active">Videos</button>
        <button className="tab">Shorts</button>
        <button className="tab">Live</button>
        <button className="tab">Posts</button>
        <button className="tab">Playlists</button>
        <button className="tab">Podcasts</button>
        <button className="tab">Promotions</button>
        <button className="tab">Collaborations</button>
      </div>

      {/* Search / Filter */}
      <div className="filter-bar">
        <input
          type="text"
          placeholder="Filter videos..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Table */}
      <table className="video-table">
        <thead>
          <tr>
            <th></th>
            <th>Video</th>
            <th>Visibility</th>
            <th>Category</th>
            <th>Date</th>
            <th>Views</th>
            <th>Likes</th>
            <th>Dislikes</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {displayed.map((video) => (
            <tr key={video.id}>
              <td>
                <input type="checkbox" />
              </td>
              <td className="video-cell">
                <div className="thumb">
                  <img src={`${BASE_URL}api/${video.image}`} alt={video.id} />
                  <span className="duration">{formatDuration(video.duration)}</span>
                </div>
                <div className="video-info">
                  <strong>{video.title}</strong>
                  <p>{limitText(video.description, 50)}</p>
                </div>
              </td>
              <td>0</td>
              <td>Publicité</td>
              <td>{formatDate(video.created_at)}</td>
              <td>0</td>
              <td>0</td>
              <td>0</td>
              <td>
                <a href="" className="upload-choose-btn" onClick={() => navigate(`/videoDetail/${video.id}`)}>Convertir</a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="pagination">
        <span>
          Rows per page: <b>{rowsPerPage}</b>
        </span>
        <span>
          {page} – {Math.ceil(filtered.length / rowsPerPage)} of{" "}
          {filtered.length}
        </span>
        <button
          disabled={page === 1}
          onClick={() => handleChangePage(page - 1)}
        >
          ‹
        </button>
        <button
          disabled={page * rowsPerPage >= filtered.length}
          onClick={() => handleChangePage(page + 1)}
        >
          ›
        </button>
      </div>
    </div>

    </div>
  );
};

export default VideoList;
